import React from 'react';
import PropTypes from 'prop-types';
import ShipFromComponent from '../../../../../fulfillment-planner/ship-from';
import classNames from 'classnames';
import { INLINE_MESSAGE_TYPES } from 'ui-components/components/inline-message';
import ShipFromLabel from '../../../../../fulfillment-planner/ship-from/label';
import ShipFromValidator from '../../../../../fulfillment-planner/ship-from/validator';
import RateBrowserButton from '../../../../../fulfillment-planner/rate-browser-button';
import style from './style.module.less';

export const ShipFrom = ({ fulfillmentPlanId }) => (
  <ShipFromValidator fulfillmentPlanId={fulfillmentPlanId} showFulfillmentProviders>
    {({ validation }) => (
      <>
        <div
          className={classNames(
            style.label,
            { [style['lable-with-helper-text']]: validation.helperText },
            {
              [style.error]: validation.helperTextType === INLINE_MESSAGE_TYPES.error,
            },
          )}
        >
          <ShipFromLabel />
        </div>
        <ShipFromComponent showFulfillmentProviders validation={validation} />
        <div>
          <RateBrowserButton fulfillmentPlanId={fulfillmentPlanId} />
        </div>
      </>
    )}
  </ShipFromValidator>
);

ShipFrom.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};
